import { createCoa, checkRes, RequestLogicError } from '@tencent/Coa';
import login from '@tencent/vft-common/login';
var getPayVipCoa = createCoa([checkRes(function (res) {
  if (res && res.result && res.result.code < 0) {
    // 未登录
    throw new RequestLogicError(res.result.msg, res.result.code, res);
  } else {
    return res;
  }
})]);
export function getPayVipFromNetwork() {
  return getPayVipCoa('//vip.video.qq.com/fcgi-bin/comm_cgi', {
    name: 'payvip',
    cmd: '1',
    getannual: 1,
    geticon: 1,
    getqquvip: 1,
    getsvip: 1,
    g_tk: login.getToken()
  });
}